module.exports = __webpack_public_path__ + "img/login-v2.f04bfd4a.svg";